<template>
  <div class="product">
    <div class="product-box">
      <div class="title">
        {{ resDatas.title }}
      </div>
      <div class="game-box">
        <ul class="gameul">
          <li
            v-for="(item, index) in resDatas.gamelist"
            :class="item.appStore == '' ? 'product-list active' : 'product-list'"
          >
            <img
              class="gameIcon"
              :src="require('@/assets/images/games/' + item.img)"
            />
            <div class="product-text">
              <h3>
                {{ item.title }} <em>{{ item.minTitle }}</em>
              </h3>
              <p>{{ item.gameIntro }}</p>
              <p>{{ item.gameIntro2 }}</p>
            </div>
            <div class="product-download" v-if="item.appStore != ''">
              <div class="download-box">
                <a><img src="~@/assets/images/ios.png"/></a>
                <a><img src="~@/assets/images/google.png"/></a>
                <a
                  ><img :src="require('@/assets/images/' + item.webText + '.png')"
                /></a>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      resDatas: ""
    };
  },
  props: {
    resData: {}
  },
  watch: {
    resData(newData) {
      this.resDatas = newData;
    }
  },
  methods: {},
  mounted() {
    this.$parent.getlan();
  }
};
</script>

<style scoped>
.product {
  background: url("~@/assets/images/games/bg2.jpg") top center no-repeat;
  background-size: cover;
  padding: 5% 0 5%;
  height: 100%;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
}

.product-box {
  width: 100%;
}

.game-box {
  max-width: 80%;
  margin: auto;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 6% 0 6%;
}

.gameul {
  border-radius: 10px;
  padding: 2%;
  box-sizing: border-box;
  background-image: url("~@/assets/images/pc-content-bg.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
}

.product-list {
  padding: 2% 4% 2%;
  background: url("~@/assets/images/fgicon.png") bottom center no-repeat;
  background-size: 100% auto;
  font-size: 0;
}

.product-list.active {
  display: flex;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}

.gameul li:nth-last-child(1) {
  background: initial;
}

.product-list::after {
  content: "";
  display: block;
  clear: both;
}

.title {
  font-size: 70px;
  text-align: center;
  background: url("~@/assets/images/title-bottom.png") center bottom no-repeat;
  background-size: auto;
  /* text-shadow: 3px 3px 3px white; */
  font-family: "dbtfont";
  padding-bottom: 12px;
  color: #ffffff;
}

.product-banner {
  padding: 2%;
}

.product-banner img {
  width: 100%;
  display: block;
}

.product-text {
  font-size: 16px;
  word-break: break-all;
  display: inline-block;
  width: 70%;
  margin-left: 3%;
}

.product-text h3 {
  font-size: 32px;
  color: #ffffff;
  font-family: "btfont";
}

.product-text h3 em {
  font-size: 20px;
  color: #898989;
  font-family: "zwfont";
  display: block;
}

.product-text p {
  font-size: 18px;
  margin-top: 1%;
  font-family: "zwfont";
  word-break: break-word;
  color: #ffffff;
}

.product-download {
  margin-top: 2%;
  display: inline-block;
  margin-left: 3%;
  width: 80%;
}

.product-download .download-title[data-v-8f06b976] {
  color: #5b6e88;
  font-size: 20px;
  text-align: center;
  background-color: white;
  padding: 1% 0;
  font-weight: 600;
}

.download-box {
  font-size: 20px;
  display: flex;
  align-items: center;
}

.download-box a {
  display: inline-block;
  cursor: pointer;
  width: 30%;
  background-color: black;
  border-radius: 5px;
  position: relative;
}

.download-box a:nth-of-type(2) {
  margin: 0 10%;
}

.download-box a img {
  width: 100%;
  display: block;
}

.gameIcon {
  width: 25%;
  display: block;
}

.download-box span {
  color: white;
  position: absolute;
  z-index: 2;
  width: 100%;
  display: block;
  top: 50%;
  transform: translateY(-50%);
  text-align: center;
}

.web-img {
  opacity: 0;
}
@media screen and (max-width: 1000px) {
  .product {
    background: url("~@/assets/images/games/h5-bg2.jpg") top center no-repeat;
    background-size: cover;
    padding: 5%;
    padding-top: 15%;
    padding-bottom: 15%;
    height: 100%;
    box-sizing: border-box;
  }

  .game-box {
    max-width: 100%;
    padding: 5% 0;
  }

  .gameul .product-list {
    padding: 4% 2% 3%;
    background-color: white;
    display: block;
    text-align: center;
  }

  .product-list:nth-of-type(1) {
    margin-bottom: 3%;
  }

  .product-download {
    width: 100%;
    margin-left: 0;
    margin-top: 5%;
  }

  .download-box a:nth-of-type(2) {
    margin: 0 3%;
  }

  .gameIcon {
    width: 70%;
    height: auto;
    float: initial;
    margin-left: 15%;
  }

  .download-box span {
    font-size: 14px;
  }

  .product-text {
    margin: 3% 0 0;
    width: 100%;
  }

  .product-text h3 {
    font-size: 18px;
  }

  .product-text p {
    font-size: 12px;
    text-align: left;
    color: #acacac;
  }

  .product-text h3 em {
    display: block;
    font-size: 12px;
  }

  .title {
    font-size: 30px;
    background: url("~@/assets/images/yd-title-bottom.png") center bottom no-repeat;
    background-size: 30%;
  }

  .gameul {
    padding: 5% 2%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/games.vue